import React from 'react';
import { Box } from '@mui/material';

interface SimpleHiveIconProps {
    size?: 'xs' | 'm' | 'xl';
    color?: string;
}

const SimpleHiveIcon: React.FC<SimpleHiveIconProps> = ({
    size = 'm',
    color = '#F8B133'
}) => {
    // Define sizes based on SmartNyuki design
    const dimensions = {
        xs: {
            width: 32,
            height: 40,
            boxHeight: 10,
            baseHeight: 6,
            baseWidth: 38,
        },
        m: {
            width: 48,
            height: 60,
            boxHeight: 15,
            baseHeight: 8,
            baseWidth: 56,
        },
        xl: {
            width: 64,
            height: 80,
            boxHeight: 20,
            baseHeight: 10,
            baseWidth: 74,
        },
    };

    const { width, height, boxHeight, baseHeight, baseWidth } = dimensions[size];
    const roofHeight = Math.round(boxHeight * 0.55);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-end',
                position: 'relative',
                width: `${baseWidth}px`,
                height: `${height + baseHeight + roofHeight}px`,
            }}
        >
            {/* Hive boxes container */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    width: `${width}px`,
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        width: 0,
                        height: 0,
                        alignSelf: 'center',
                        borderLeft: `${width / 2 + 3}px solid transparent`,
                        borderRight: `${width / 2 + 3}px solid transparent`,
                        borderBottom: `${roofHeight}px solid ${color}`,
                        filter: 'brightness(0.92)',
                        mb: '-1px',
                    }}
                />
                {/* Top box */}
                <Box
                    sx={{
                        width: '100%',
                        height: `${boxHeight}px`,
                        backgroundColor: color,
                        border: '1px solid rgba(0, 0, 0, 0.25)',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.35)',
                    }}
                />

                {/* Middle box */}
                <Box
                    sx={{
                        width: '100%',
                        height: `${boxHeight}px`,
                        backgroundColor: color,
                        border: '1px solid rgba(0, 0, 0, 0.25)',
                        borderTop: 'none',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.35)',
                    }}
                />

                {/* Bottom box */}
                <Box
                    sx={{
                        width: '100%',
                        height: `${boxHeight}px`,
                        backgroundColor: color,
                        border: '1px solid rgba(0, 0, 0, 0.25)',
                        borderTop: 'none',
                    }}
                />
            </Box>

            {/* Base/Stand */}
            <Box
                sx={{
                    width: `${baseWidth}px`,
                    height: `${baseHeight}px`,
                    backgroundColor: '#666',
                    borderTop: '2px solid rgba(0, 0, 0, 0.4)',
                    borderRadius: '0 0 2px 2px',
                    position: 'relative',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '80%',
                        height: '2px',
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    },
                }}
            />
        </Box>
    );
};

export default SimpleHiveIcon;
